var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapping"},[_c('div',{staticClass:"container"},[_vm._v(" Sorry, this page doesn't exist. ")])])
}]

export { render, staticRenderFns }